import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './data/ja.json';
import en from './data/en.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ja: { translation: ja },
      en: { translation: en },
    },
    lng: 'ja',           // ✅ Japanese is default
    fallbackLng: 'en',   // ✅ fall back to English if a key is missing in ja.json
    interpolation: { escapeValue: false },
  });

export default i18n;